import i18n from "i18n-js";

const en = require("./en");
const ja = require("./ja");

const enAuth = require("../auth/en");
const enDevice = require("../device/en");
const enUsers = require("../users/en");
const enPractices = require("../organizations/en");
const enToDo = require("../todo/en");
const enPatient = require("../patient/en");
const enMessage = require("../message/en.json");
const enNote = require("../note/en.json");
const enBilling = require("../billing/en.json");
const enVital=require('../vital/en.json')
const enTimeTracking=require('../Timetracking/en.json')
const enPatientDevice = require("../reminder/en.json");
const enPatientSettings = require('../setting/en.json');
const enCallLogs=require('../callLog/en.json')

Object.assign(
  en,
  enAuth,
  enDevice,
  enUsers,
  enPractices,
  enToDo,
  enPatient,
  enMessage,
  enNote,
  enBilling,
  enPatientDevice,
  enPatientSettings,
  enVital,
  enTimeTracking,
  enCallLogs
);

i18n.fallbacks = true;
i18n.translations = { en, ja };

const fallback = { languageTag: "en", isRTL: false };
const { languageTag } = fallback;
i18n.locale = languageTag;
